// Google analytics functionality

window.dataLayer = window.dataLayer || [];

const _ga = (function () {
  
  function dataLayerPush(pushEvent) {
    window.dataLayer.push(pushEvent);
  };

  function mapOrderContainerSize(containerSizeText) {
    if (containerSizeText == null) {
      return null;
    }
    switch(containerSizeText) {
      case "Large Container":
        return "Large";
      case "Medium Container": 
        return "Medium";
      case "Small Container":
        return "Small"
    }
    return null;
  }

  function mapOrderEventCode(moveLegCode) {
    switch(moveLegCode) {
      case "MOV": 
        return "Schedule Move";
      case "RDL":
        return "Schedule Delivery";
      case "FPU":
        return "Schedule Return";
      case "WRT":
        return "Schedule Pickup";
      default:
        return "";
    }
  }

  function createLegToGaEvent(legId, oldOrders, newOrders, userId) {

    if (legId == null || oldOrders == null || oldOrders.length < 0 || newOrders == null || newOrders.length < 0) {
      return null;
    }

    let orderId = null;
    let oldQuoteId = null;
    let containerId = null;
    let oldLegId = null;
    let oldScheduleDate = null;

    // Finding leg object in old orders
    for(let i = 0; i < oldOrders.length; i++) { // orders
      for(let j = 0; j < oldOrders[i].Containers.length; j++) { // containers
        for (let k = 0; k < oldOrders[i].Containers[j].MoveLegs.length; k++) { // legs
          let oContainer = oldOrders[i].Containers[j];
          let oLeg = oContainer.MoveLegs[k];
          if (oLeg.MoveLegId == legId) {
            orderId = oContainer.OrderId;
            oldQuoteId = oContainer.QuoteId;
            containerId = oContainer.ContainerId;
            oldLegId = oLeg.MoveLegId;
            oldScheduleDate = oLeg.ScheduledDate;
          }
        }
      }
    }

    if (orderId == null || oldQuoteId == null || containerId == null || oldLegId == null) {
      return null;
    }

    // Finding leg in new orders and create push object
    for(let i = 0; i < newOrders.length; i++) { // orders
      for(let j = 0; j < newOrders[i].Containers.length; j++) { // containers
        if (newOrders[i].Containers[j].OrderId !== orderId && newOrders[i].Containers[j].ContainerId !== containerId) {
          continue;
        }
        // Creating new legId based on new quoteID
        const newLegId = newOrders[i].Containers[j].QuoteId + oldLegId.replace(oldQuoteId, '');
        for (let k = 0; k < newOrders[i].Containers[j].MoveLegs.length; k++) { // legs
          const oContainer = newOrders[i].Containers[j];
          const oLeg = oContainer.MoveLegs[k];
          if (oLeg.MoveLegId == newLegId) {
            let container = {
              user_id: userId,
              order_id: oContainer.OrderId,
              order_type: oContainer.OrderType,
              order_date: oContainer.OrderDate,
              quote_id: oContainer.QuoteId,
            }

            // Checking if it's a reschedule
            if (oldScheduleDate !== null) {
              container.event = "Edit Delivery";
                container.move_leg_details = {
                  move_leg_code: oLeg.MoveLegType,
                  delivery_details: {
                    delivery_date: oLeg.ScheduledDate,
                    delivery_location: {
                      postal_code: oLeg.Address.PostalCode,
                      city: oLeg.Address.City,
                      state: oLeg.Address.State
                    }
                  }
                };
                return container;
            }

            // Checking Move Leg Type
            switch(oLeg.MoveLegType) {
              case "MOV": 
                container.event = mapOrderEventCode(oLeg.MoveLegType);
                container.move_leg_details = {
                  move_leg_code: oLeg.MoveLegType,
                  container_size: mapOrderContainerSize(oContainer.ContainerType),
                  delivery_details: {
                    delivery_date: oLeg.ScheduledDate,
                    delivery_location: {
                      postal_code: oLeg.Address.PostalCode,
                      city: oLeg.Address.City,
                      state: oLeg.Address.State
                    }
                  }
                };
                break;
              case "RDL":
                container.event = mapOrderEventCode(oLeg.MoveLegType);
                container.confirm_placement = 'True',
                container.move_leg_details = {
                  move_leg_code: oLeg.MoveLegType,
                  delivery_details: {
                    delivery_date: oLeg.ScheduledDate,
                    delivery_location: {
                      postal_code: oLeg.Address.PostalCode,
                      city: oLeg.Address.City,
                      state: oLeg.Address.State
                    }
                  }
                };
                break;
              case "FPU":
                container.event = mapOrderEventCode(oLeg.MoveLegType);
                container.move_leg_details = {
                  move_leg_code: oLeg.MoveLegType,
                  delivery_details: {
                    delivery_date: oLeg.ScheduledDate,
                    delivery_location: {
                      postal_code: oLeg.Address.PostalCode,
                      city: oLeg.Address.City,
                      state: oLeg.Address.State
                    }
                  }
                };
                break;
              case "WRT":
                container.event = mapOrderEventCode(oLeg.MoveLegType);
                container.move_leg_details = {
                  move_leg_code: oLeg.MoveLegType,
                  pickup_details: {
                    pickup_date: oLeg.ScheduledDate,
                    pickup_location: {
                      postal_code: oLeg.Address.PostalCode,
                      city: oLeg.Address.City,
                      state: oLeg.Address.State
                    }
                  }
                };
                break;
              default:
                return null;
            }
            return container;
          }
        }
      }
    }
    return null;
  }

  function pushMoveLegSubmit(legId, oldOrders, newOrders, userId) {
    try {
      var gaEvent = createLegToGaEvent(legId, oldOrders, newOrders, userId);
      if (gaEvent) {
        dataLayerPush(gaEvent);
      }
    } catch(err) {
      console.error(err); 
    }
  }

  function pushMoveLegError(moveLegCode, errorType, errorLabel, errorSource, userId) {
    try {
      const errorEvent = {
        'event': 'ERROR: ' + mapOrderEventCode(moveLegCode),
        error_details: {
          move_leg_code: moveLegCode,
          error_payload: {
            error_type: errorType,
            error_label: errorLabel,
            error_source: errorSource,
            user_id: userId  
          }
        }
      };
      dataLayerPush(errorEvent);
    } catch(err) {
      console.error(err)
    }
  }

  return {
    pushMoveLegSubmit: pushMoveLegSubmit,
    pushMoveLegError: pushMoveLegError
  };
})();
